module.exports = __webpack_public_path__ + "img/palmas-pool.b65b64cd.jpg";